/**
 * Reload the page when the signed-in account changes under a tab that is already open (MAR-1408).
 *
 * Firebase Auth is shared by every tab of a browser, so a sign-out or a different sign-in in tab A
 * reaches tab B through `onIdTokenChanged`. B's `user.value` follows, but everything keyed to the
 * previous account does not: the `user-profile` state (sidebar, organization name), the lists and the
 * route gate, which only runs on navigation. The tab then looks like the old account while its
 * requests carry the new one. A reload is the one reset that cannot miss a piece of that state, and
 * the route middleware then judges the NEW account from scratch.
 *
 * `previousUid` is what this tab was showing. It is null for the first account the tab sees, and for a
 * sign-out this tab started itself (`signOut()` clears `user.value` first and navigates away anyway),
 * so neither reloads. A token refresh for the same account does not either.
 */
export function reloadOnAccountSwitch(
  previousUid: string | null | undefined,
  nextUid: string | null | undefined,
  reload: () => void = () => window.location.reload(),
): boolean {
  if (!previousUid) return false
  if (previousUid === (nextUid ?? null)) return false
  reload()
  return true
}
